// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--36YE3","container-static":"dece2e673c--container-static--1ahkQ","container-fixed":"dece2e673c--container-fixed--2UCyZ"};